import Component from '../classes/Component';
import countries from '../../data/countries.json';

export default class extends Component {
	constructor({ element, form }) {
		super({
			element,
			elements: {
				countryCode: '[data-trigger]',
				countrySearch: '.c-contact__search',
				template: 'template',
				searchbar: '.c-contact__search-bar input',
			},
		});

		this.form = form;
		this.searchMenuOpen = false;

		this.handleDropdown();
	}

	showDropdown() {
		this.elements.countrySearch.classList.add('active');
		setTimeout(() => {
			this.searchMenuOpen = true;
		}, 200);
	}

	hideDropdown() {
		this.searchMenuOpen = false;
		this.elements.countrySearch.classList.remove('active');
	}

	handleDropdown() {
		const {
			countryCode, countrySearch, template, searchbar,
		} = this.elements;
		const countryKeys = Object.keys(countries);

		countryKeys.forEach(key => {
			const country = countries[key];
			const clone = template.content.cloneNode(true);
			const text = clone.querySelectorAll('p');
			text[0].innerHTML = `${country['Country Flag']}  <span>${country['Country Name']}</span>`;
			if (text[1]) {
				text[1].textContent = `+${country['Calling Code']}`;
			}
			countrySearch.appendChild(clone);
		});

		const countryNodes = this.element.querySelectorAll('.c-contact__search-country');
		countryNodes.forEach(country => {
			country.addEventListener('click', () => {
				const texts = country.querySelectorAll('p');
				if (texts[1]) {
					countryCode.value = texts[1].textContent;
				} else {
					const selectedCountry = texts[0].querySelector('span').textContent;
					countryCode.value = selectedCountry;
					countryCode.dataset.country = selectedCountry;
				}
				this.hideDropdown();
			});
		});

		countryCode.addEventListener('focus', () => {
			this.showDropdown();
			this.elements.searchbar.focus();
		});

		searchbar.addEventListener('keyup', e => {
			const value = e.target.value.toLowerCase();
			if (value) {
				Object.keys(countries).forEach((key, i) => {
					const country = countries[key];
					const isCountryMatch = country['Country Name'].toLowerCase().includes(value);
					const isCodeMatch = country['Calling Code'].toString().toLowerCase().includes(value);
					if (isCountryMatch || isCodeMatch) {
						countryNodes[i].style.display = null;
					} else {
						countryNodes[i].style.display = 'none';
					}
				});
			}
		});
		this.form.addEventListener('click', e => {
			if (this.searchMenuOpen) {
				const targetIsSearchMenu = e.target.classList.contains('c-contact__search');
				const targetParentIsSearchMenu = e.target.parentElement.classList.contains('c-contact__search');
				const targetGrandparentIsSearchMenu = e.target.parentElement.parentElement.classList.contains('c-contact__search');
				const targetisTrigger = e.target === countryCode;

				if (!targetIsSearchMenu && !targetParentIsSearchMenu && !targetGrandparentIsSearchMenu && !targetisTrigger) {
					this.hideDropdown();
				}
			}
		});
	}
}
